(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-application-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-aaf-form]').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    var hp = form.querySelector('[data-aaf-hp]');
    if (hp && hp.value.trim() !== '') { e.preventDefault(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
// „Cookie-Einstellungen“ — öffnet die Consent-Präferenzen erneut.
// Nutzt die offizielle Shopify-Customer-Privacy-/Banner-API, wenn vorhanden;
// andernfalls navigiert der Link zur Datenschutzseite (ehrlicher Fallback,
// niemals eine funktionslose Schaltfläche).
document.querySelectorAll('[data-iw-cookie-settings]').forEach(function (el) {
  el.addEventListener('click', function (e) {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      e.preventDefault();
      window.privacyBanner.showPreferences();
    } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openConsentManager === 'function') {
      e.preventDefault();
      window.Shopify.customerPrivacy.openConsentManager();
    }
    // else: allow default navigation to the privacy policy (cookie section).
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-contact-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-iwc-form]').forEach(function (form) {
  form.addEventListener('submit', function (e) {
    var hp = form.querySelector('[data-iwc-hp]');
    if (hp && hp.value.trim() !== '') { e.preventDefault(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.hsInit) return;
      root.dataset.hsInit = '1';
      var track = root.querySelector('.iw-hslide__track');
      var slides = Array.prototype.slice.call(root.querySelectorAll('.iw-hslide__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.iw-hslide__dot'));
      var n = slides.length;
      if (!track || n <= 1) return;

      var i = 0;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      var autoplay = root.getAttribute('data-autoplay') !== 'false';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;

      function go(idx) {
        i = (idx + n) % n;
        track.style.setProperty('--i', i);
        dots.forEach(function (d, di) {
          var on = di === i;
          d.classList.toggle('is-active', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        slides.forEach(function (s, si) {
          if (si === i) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
          var a = s.querySelector('.iw-hslide__link');
          if (a) { if (si === i) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
        });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { if (!autoplay || reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, interval); }

      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { go(di); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
        start();
      }, { passive: true });

      go(0);
      start();
    }
    function initAll(ctx) {
      (ctx || document).querySelectorAll('.iw-hslide').forEach(init);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('.iw-hslide') || e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-inspiration-galerie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var clip = section.querySelector('.iw-inspo__clip');
      var toggle = section.querySelector('.iw-inspo__toggle');
      if (!clip || !toggle || toggle.dataset.inspoInit) return;
      toggle.dataset.inspoInit = '1';
      var label = toggle.querySelector('.iw-inspo__toggle-label');

      function fullHeight() {
        return clip.scrollHeight + 'px';
      }

      toggle.addEventListener('click', function () {
        var collapsed = clip.getAttribute('data-collapsed') !== 'false';
        if (collapsed) {
          clip.style.setProperty('--inspo-h-open', fullHeight());
          clip.setAttribute('data-collapsed', 'false');
          toggle.setAttribute('aria-expanded', 'true');
          if (label) label.textContent = toggle.dataset.less || label.textContent;
        } else {
          clip.style.setProperty('--inspo-h-open', fullHeight());
          requestAnimationFrame(function () {
            clip.setAttribute('data-collapsed', 'true');
            toggle.setAttribute('aria-expanded', 'false');
            if (label) label.textContent = toggle.dataset.more || label.textContent;
          });
          var head = section.querySelector('.iw-inspo__head');
          if (head && head.getBoundingClientRect().top < 0) {
            head.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });

      window.addEventListener('resize', function () {
        if (clip.getAttribute('data-collapsed') === 'false') {
          clip.style.setProperty('--inspo-h-open', fullHeight());
        }
      });
    }
    function initAll(ctx) {
      (ctx || document).querySelectorAll('.iw-inspo').forEach(init);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-legal"] && !Shopify.designMode) return;
  try {
    
// Copy-to-clipboard for the model withdrawal form (progressive enhancement).
document.querySelectorAll('[data-iw-copy]').forEach(function (btn) {
  var box = btn.closest('.iw-copybox');
  var src = box && box.querySelector('[data-iw-copy-source]');
  if (!src) return;
  var original = btn.textContent;
  btn.addEventListener('click', function () {
    var text = src.innerText;
    var done = function () {
      btn.textContent = btn.getAttribute('data-copied') || 'Kopiert';
      setTimeout(function () { btn.textContent = original; }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done).catch(function () { done(); });
    } else {
      var r = document.createRange();
      r.selectNodeContents(src);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
      try { document.execCommand('copy'); } catch (e) {}
      sel.removeAllRanges();
      done();
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-material-filter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMf(root) {
      if (root.dataset.mfInit) return;
      root.dataset.mfInit = '1';
      var pills = Array.prototype.slice.call(root.querySelectorAll('.iw-mf__pill'));
      var items = Array.prototype.slice.call(root.querySelectorAll('.iw-mf__item'));
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile-base]'));
      var moreBtn = root.querySelector('[data-mf-more]');
      var secondary = root.querySelector('[data-mf-secondary]');
      var activeLine = root.querySelector('[data-mf-active]');
      if (!pills.length) return;

      function setExpanded(on) {
        if (!moreBtn || !secondary) return;
        moreBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (on) secondary.removeAttribute('hidden');
        else secondary.setAttribute('hidden', '');
      }
      if (moreBtn) {
        moreBtn.addEventListener('click', function () {
          setExpanded(moreBtn.getAttribute('aria-expanded') !== 'true');
        });
      }

      function withMaterial(base, mf) {
        return mf === 'all' ? base : base + '?material=' + encodeURIComponent(mf);
      }

      function updateCard(it, mf) {
        var priceEl = it.querySelector('.iw-pcard__price');
        if (priceEl) {
          if (priceEl.dataset.allHtml == null) priceEl.dataset.allHtml = priceEl.innerHTML;
          var pmap = {};
          try { pmap = JSON.parse(it.getAttribute('data-mat-prices') || '{}'); } catch (e) {}
          if (mf !== 'all' && pmap[mf]) priceEl.textContent = pmap[mf];
          else priceEl.innerHTML = priceEl.dataset.allHtml;
        }
        var img = it.querySelector('.iw-pcard__img--1');
        if (img) {
          if (img.dataset.allSrc == null) {
            img.dataset.allSrc = img.getAttribute('src') || '';
            img.dataset.allSrcset = img.getAttribute('srcset') || '';
          }
          var imap = {};
          try { imap = JSON.parse(it.getAttribute('data-mat-images') || '{}'); } catch (e) {}
          var url = mf === 'all' ? null : imap[mf];
          if (url) {
            img.setAttribute('src', url);
            img.setAttribute('srcset',
              url.replace('width=700', 'width=350') + ' 350w, ' + url + ' 700w, ' + url.replace('width=700', 'width=900') + ' 900w');
          } else {
            img.setAttribute('src', img.dataset.allSrc);
            if (img.dataset.allSrcset) img.setAttribute('srcset', img.dataset.allSrcset);
            else img.removeAttribute('srcset');
          }
        }
        var img2 = it.querySelector('.iw-pcard__img--2');
        if (img2) img2.style.display = mf === 'all' ? '' : 'none';
        var a = it.querySelector('a[href]');
        if (a) {
          if (!a.dataset.baseHref) a.dataset.baseHref = a.getAttribute('href').split('?')[0];
          a.setAttribute('href', withMaterial(a.dataset.baseHref, mf));
        }
      }

      function updateTile(t, mf) {
        var priceEl = t.querySelector('[data-tile-price]');
        if (priceEl) {
          if (priceEl.dataset.allHtml == null) priceEl.dataset.allHtml = priceEl.innerHTML;
          var pmap = {};
          try { pmap = JSON.parse(t.getAttribute('data-mat-prices') || '{}'); } catch (e) {}
          if (mf !== 'all' && pmap[mf]) priceEl.textContent = pmap[mf];
          else priceEl.innerHTML = priceEl.dataset.allHtml;
        }
        var base = t.dataset.tileBase || (t.dataset.tileBase = t.getAttribute('href').split('?')[0]);
        t.setAttribute('href', withMaterial(base, mf));
      }

      function apply(mf) {
        items.forEach(function (it) { updateCard(it, mf); });
        tiles.forEach(function (t) { updateTile(t, mf); });
      }

      function select(pill) {
        var mf = pill.getAttribute('data-mf');
        pills.forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (activeLine) {
          if (mf === 'all') { activeLine.setAttribute('hidden', ''); activeLine.textContent = ''; }
          else { activeLine.textContent = pill.getAttribute('data-full') || ''; activeLine.removeAttribute('hidden'); }
        }
        if (secondary && secondary.contains(pill)) setExpanded(true);
        apply(mf);
      }
      pills.forEach(function (p) { p.addEventListener('click', function () { select(p); }); });
    }

    function initRow(wrap) {
      if (wrap.dataset.mfRowInit) return;
      wrap.dataset.mfRowInit = '1';
      var row = wrap.querySelector('[data-mf-row]');
      var prev = wrap.querySelector('[data-mf-prev]');
      var next = wrap.querySelector('[data-mf-next]');
      if (!row) return;
      function page(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) { if (row.scrollLeft <= 2) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled'); }
        if (next) { if (row.scrollLeft >= max) next.setAttribute('disabled', ''); else next.removeAttribute('disabled'); }
      }
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    function initAll(ctx) {
      var c = ctx || document;
      c.querySelectorAll('.iw-mf').forEach(initMf);
      c.querySelectorAll('[data-mf-rowwrap]').forEach(initRow);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initRow(wrap) {
      if (wrap.dataset.prowInit) return;
      wrap.dataset.prowInit = '1';
      var row = wrap.querySelector('[data-prow-row]');
      var prev = wrap.querySelector('[data-prow-prev]');
      var next = wrap.querySelector('[data-prow-next]');
      if (!row) return;
      function page(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) { if (row.scrollLeft <= 2) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled'); }
        if (next) { if (row.scrollLeft >= max) next.setAttribute('disabled', ''); else next.removeAttribute('disabled'); }
      }
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      /* Auch nach dem Laden der Bilder noch einmal: sonst kann der Pfeil-Zustand
         von einer zu frueh gemessenen scrollWidth haengen bleiben. */
      window.addEventListener('load', sync);
      sync();
    }

    function initAll(ctx) {
      var c = ctx || document;
      c.querySelectorAll('[data-prow-wrap]').forEach(initRow);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    /* Im Customizer läuft der globale Reveal-Observer (icon-walls.js) nach einem
       Section-Reload nicht erneut — ohne das hier bliebe die Reihe auf opacity:0. */
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
      e.target.querySelectorAll('.iw-reveal').forEach(function (el) { el.classList.add('iw-in'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-trustpilot"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(wrap) {
    var slider = wrap.querySelector('[data-rev-slider]');
    if (!slider) return;
    var prev = wrap.querySelector('[data-rev-prev]');
    var next = wrap.querySelector('[data-rev-next]');
    if (!prev || !next) return;
    function schritt() {
      var erste = slider.firstElementChild;
      return erste ? erste.getBoundingClientRect().width + 14 : slider.clientWidth * 0.8;
    }
    function sync() {
      prev.disabled = slider.scrollLeft <= 4;
      next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
    }
    prev.addEventListener('click', function () { slider.scrollBy({ left: -schritt(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { slider.scrollBy({ left: schritt(), behavior: 'smooth' }); });
    slider.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function initTopics(sec) {
    var pills = sec.querySelectorAll('[data-rev-pill]');
    if (!pills.length) return;
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var ziel = pill.getAttribute('data-rev-pill');
        pills.forEach(function (p) {
          var aktiv = p === pill;
          p.classList.toggle('is-active', aktiv);
          p.setAttribute('aria-selected', aktiv ? 'true' : 'false');
        });
        sec.querySelectorAll('[data-rev-topic]').forEach(function (w) {
          w.hidden = w.getAttribute('data-rev-topic') !== ziel;
        });
      });
    });
  }

  function initQuotes(sec) {
    var box = sec.querySelector('[data-rev-quotes]');
    if (!box) return;
    var zitate = box.querySelectorAll('[data-rev-quote]');
    if (zitate.length < 2) return;
    var dots = box.querySelector('[data-rev-dots]');
    var i = 0, timer = null;
    zitate.forEach(function (_, n) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'iw-rev__dot' + (n === 0 ? ' is-active' : '');
      d.setAttribute('aria-label', 'Bewertung ' + (n + 1));
      d.addEventListener('click', function () { zeige(n); starte(); });
      dots.appendChild(d);
    });
    function zeige(n) {
      i = n;
      box.classList.add('is-fading');
      setTimeout(function () {
        zitate.forEach(function (z, k) { z.hidden = k !== n; });
        dots.querySelectorAll('.iw-rev__dot').forEach(function (d, k) { d.classList.toggle('is-active', k === n); });
        box.classList.remove('is-fading');
      }, 420);
    }
    function starte() {
      if (timer) clearInterval(timer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { zeige((i + 1) % zitate.length); }, 7000);
    }
    starte();
  }

  function initMini(sec) {
    var btn = sec.querySelector('[data-rev-minitoggle]');
    var panel = sec.querySelector('[data-rev-minipanel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var offen = panel.hidden;
      panel.hidden = !offen;
      btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
      btn.textContent = offen ? 'Schliessen' : 'Bewertungen lesen';
    });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-iw-rev]').forEach(function (sec) {
      if (sec.dataset.revReady === '1') return;
      sec.dataset.revReady = '1';
      sec.querySelectorAll('.iw-rev__sliderwrap, .iw-rev__topicwrap, .iw-rev__minipanel').forEach(initSlider);
      initSlider(sec);
      initTopics(sec);
      initQuotes(sec);
      initMini(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iw-withdrawal-form"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-wd-form]').forEach(function (form) {
  form.classList.add('iw-wd--js');

  var step1 = form.querySelector('[data-wd-step="1"]');
  var step2 = form.querySelector('[data-wd-step="2"]');
  var nextBtn = form.querySelector('[data-wd-next]');
  var backBtn = form.querySelector('[data-wd-back]');
  var review = form.querySelector('[data-wd-review]');
  var hp = form.querySelector('[data-wd-hp]');
  var tsField = form.querySelector('[data-wd-timestamp]');
  var bodyField = form.querySelector('[data-wd-body]');
  var itemsWrap = form.querySelector('[data-wd-items]');
  var itemsInput = itemsWrap ? itemsWrap.querySelector('textarea') : null;

  // Toggle "individual items" textarea + its required state.
  form.querySelectorAll('[data-wd-scope]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var showItems = form.querySelector('[data-wd-scope="items"]').checked;
      if (itemsWrap) itemsWrap.hidden = !showItems;
      if (itemsInput) itemsInput.required = showItems;
    });
  });

  function labelFor(el) {
    var lbl = el.closest('.iw-wd__field');
    lbl = lbl && (lbl.querySelector('label') || lbl.querySelector('legend'));
    return lbl ? lbl.textContent.replace('*', '').trim() : '';
  }

  function scopeText() {
    var checked = form.querySelector('[data-wd-scope]:checked');
    return checked ? checked.value : '';
  }

  function buildReview() {
    if (!review) return;
    review.innerHTML = '';
    var rows = [
      ['name', form.querySelector('[data-wd-in="name"]')],
      ['email', form.querySelector('[data-wd-in="email"]')],
      ['order', form.querySelector('[data-wd-in="order"]')]
    ];
    rows.forEach(function (r) {
      if (r[1] && r[1].value.trim()) addRow(labelFor(r[1]), r[1].value.trim());
    });
    addRow(form.querySelector('.iw-wd__scope legend') ? form.querySelector('.iw-wd__scope legend').textContent.replace('*','').trim() : 'Umfang', scopeText());
    if (itemsInput && itemsInput.value.trim()) addRow(labelFor(itemsInput), itemsInput.value.trim());
    ['ordered', 'delivered', 'message', 'reason'].forEach(function (key) {
      var el = form.querySelector('[data-wd-in="' + key + '"]');
      if (el && el.value.trim()) addRow(labelFor(el), el.value.trim());
    });
  }

  function addRow(term, val) {
    var dt = document.createElement('dt');
    var dd = document.createElement('dd');
    dt.textContent = term;
    dd.textContent = val;
    review.appendChild(dt);
    review.appendChild(dd);
  }

  function stamp() {
    var now = new Date();
    if (tsField) tsField.value = now.toLocaleString();
    // Human-readable combined body for the merchant e-mail + sessionStorage.
    var parts = [];
    form.querySelectorAll('[data-wd-in]').forEach(function (el) {
      if (el.value && el.value.trim() && el.type !== 'radio') parts.push(labelFor(el) + ': ' + el.value.trim());
    });
    parts.push((form.querySelector('.iw-wd__scope legend') ? 'Umfang' : 'Umfang') + ': ' + scopeText());
    if (bodyField) bodyField.value = parts.join('\n');
    try {
      sessionStorage.setItem('iwWithdraw', JSON.stringify({
        name: (form.querySelector('[data-wd-in="name"]') || {}).value || '',
        order: (form.querySelector('[data-wd-in="order"]') || {}).value || '',
        scope: scopeText(),
        content: (bodyField ? bodyField.value : ''),
        date: now.toLocaleDateString(),
        time: now.toLocaleTimeString()
      }));
    } catch (e) {}
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      // Validate only the required fields of step 1.
      var required = step1.querySelectorAll('[required]');
      for (var i = 0; i < required.length; i++) {
        if (!required[i].checkValidity()) { required[i].reportValidity(); return; }
      }
      buildReview();
      step1.classList.add('iw-wd__step1-hidden');
      step2.classList.add('is-active');
      step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (backBtn) {
    backBtn.addEventListener('click', function () {
      step2.classList.remove('is-active');
      step1.classList.remove('iw-wd__step1-hidden');
      step1.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  form.addEventListener('submit', function (e) {
    if (hp && hp.value.trim() !== '') { e.preventDefault(); return; }
    stamp();
  });

  // Post-reload confirmation: fill receipt details from sessionStorage.
  var receipt = form.querySelector('[data-wd-receipt]');
  if (receipt) {
    try {
      var data = JSON.parse(sessionStorage.getItem('iwWithdraw') || 'null');
      if (data) {
        var set = function (k, v) { var el = receipt.querySelector('[data-wd-r="' + k + '"]'); if (el && v) el.textContent = v; };
        set('name', data.name);
        set('order', data.order);
        set('scope', data.scope);
        set('content', data.content);
        set('date', data.date);
        set('time', data.time);
        receipt.hidden = false;
      }
      sessionStorage.removeItem('iwWithdraw');
    } catch (e) {}
  }

  var printBtn = form.querySelector('[data-wd-print]');
  if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limited-drops"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRow(wrap) {
      if (wrap.dataset.ldInit) return;
      wrap.dataset.ldInit = '1';
      var row = wrap.querySelector('[data-ld-row]');
      var prev = wrap.querySelector('[data-ld-prev]');
      var next = wrap.querySelector('[data-ld-next]');
      if (!row) return;
      function page(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.9, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { page(-1); });
      if (next) next.addEventListener('click', function () { page(1); });
      function sync() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) { if (row.scrollLeft <= 2) prev.setAttribute('disabled', ''); else prev.removeAttribute('disabled'); }
        if (next) { if (row.scrollLeft >= max) next.setAttribute('disabled', ''); else next.removeAttribute('disabled'); }
      }
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    function initAll(ctx) { (ctx || document).querySelectorAll('[data-ld-rowwrap]').forEach(initRow); }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
